export default __webpack_public_path__ + "static/media/tiktok.5a71116d.svg";